<template>
    <div class="border rounded" v-if="image">
        <div class="bg-gray-300 p-2">
          <button-white @click="type = 'rectangle'" class="mr-4" :class="{'border-blue-500': type === 'rectangle'}">
            <i v-if="type === 'rectangle'" class="fa fa-square-o fa-lg"></i>
            <i v-else class="fa fa-square-o" style="color: grey"></i>
          </button-white>
          <button-white @click="type = 'circle'" class="mr-4" :class="{'border-blue-500': type === 'circle'}">
            <i v-if="type === 'circle'" class="fa fa-circle-o fa-lg"></i>
            <i v-if="type !== 'circle'" class="fa fa-circle-o" style="color: grey"></i>
          </button-white>
          <button-white @click="detection = !detection" class="mr-4" :class="{'border-blue-500': detection}">
            <i v-if="!detection" class="fa fa-magic" style="color: grey"></i>
            <i v-else class="fa fa-magic fa-lg"></i>
          </button-white>
          <button-white v-show="type === 'rectangle'" @click="rotateLeft" class="mr-4" :class="{'border-blue-500': type === 'rectangle'}">
            <i class="fa fa-undo"></i>
          </button-white>
          <button-white v-show="type === 'rectangle'" @click="rotateRight" :class="{'border-blue-500': type === 'rectangle'}">
            <i class="fa fa-repeat" ></i>
          </button-white>

            <div v-show="type === 'rectangle'">
                <input-text v-model="width">
                    Breite
                </input-text>

                <input-text v-model="height">
                    Höhe
                </input-text>
            </div>

            <div v-show="type === 'circle'">
                <input-text v-model="radius">
                    Radius
                </input-text>
            </div>

        </div>

        <div id="map" style="width:600px;height:400px;" class="p-2"></div>
    </div>
</template>

<script>
import L from "leaflet";
import Card from "../UI/Card";
import ButtonPrimary from "../UI/ButtonPrimary";
import SelectMenu from "../UI/SelectMenu";
import InputText from "../UI/InputText";
import ButtonWhite from "../UI/ButtonWhite";

export default {
    name: "BookablePositionEdit",
    components: {
        ButtonWhite,
        InputText,
        SelectMenu,
        ButtonPrimary,
        Card},

    props: ['value'],

    data: (vm) => ({
        height: vm.value.position ? vm.value.position.height : 10,
        width: vm.value.position ? vm.value.position.width : 10,
        radius: vm.value.position ? vm.value.position.radius : 10,
        type: vm.value.position ? vm.value.position.type : 'rectangle',
        center: vm.value.position ? vm.value.position.center : [0, 0],
        selectedId: null,
        map: null,
        rectangle: null,
        bookables: [],
        canvas: null,
        data: [],
        detection: true,
        disableClick: false,
        defaultPosition: null,
    }),

    watch: {
        height() {
            this.updatePosition(this.center);
        },
        width() {
            this.updatePosition(this.center);
        },
        type() {
            this.updatePosition(this.center);
        },
        radius() {
            this.updatePosition(this.center);
        },
    },

    computed: {
        item: {
            get() {
                return this.value;
            },
            set(value) {
                return this.$emit('input', value);
            },
        },
        image() {
            return this.item.floor?.map_link ?? null;
        },
    },

    mounted() {

        if (!this.image) {
            return;
        }

        this.load();
        this.loadFloor();
    },

    methods: {
        loadFloor() {
            window.axios
                .get(`/admin/floors/${this.item.floor_id}`)
                .then(result => {
                    this.bookables = result.data.data.bookables.filter(bookable => {
                        return bookable.position && bookable.position.center[0];
                    });
                    this.paintBookables();
                    this.setZoom();
                });
        },
        paintBookables() {
            this.bookables
                .filter(bookable => bookable.id !== this.item.id)
                .forEach(item => {
                    if (!item.position) {
                        return;
                    }
                    if (item.position.type === 'circle') {
                        L.circle(item.position.center, {color: "blue", radius: item.position.radius, weight: 1})
                            .addTo(this.map);

                        return;
                    }

                    let rect = L.rectangle([
                        [item.position.center[0] + item.position.height, item.position.center[1] - item.position.width],
                        [item.position.center[0] - item.position.height, item.position.center[1] + item.position.width],
                    ], {color: "blue", weight: 1})
                        .addTo(this.map);

                    this.rotateRectangle(item, rect);
                });
        },
        setZoom() {
            //determine desk most left, top, right and bottom value!
            if (this.bookables.length === 0) {
                return; // TODO set ZOOM to all of the map!
            }

            let [l, t] = this.bookables[0].position.center;
            let [r, b] = this.bookables[0].position.center;

            this.bookables.forEach(desk => {
                l = Math.min(l, desk.position.center[0]);
                b = Math.min(b, desk.position.center[1]);
                r = Math.max(r, desk.position.center[0]);
                t = Math.max(t, desk.position.center[1]);
            })

            this.map.fitBounds([
                [l, t],
                [r, b]
            ]);
        },
        load() {
            const img = new Image();

            img.onload = () => {

                let minZoom = - Math.ceil( Math.max(img.width + img.height) / 1000 );
                this.map = L.map('map', {
                    crs: L.CRS.Simple,
                    minZoom: minZoom,
                    maxZoom: 2,
                    zoomSnap: 0.1,
                });

                this.createMap(img.width, img.height)
                this.loadCanvas(img);
            }

            img.src = this.image;
            img.crossOrigin = "Anonymous";
        },
        loadCanvas(img) {
          this.canvas = document.createElement('canvas');
          this.canvas.width = img.width;
          this.canvas.height = img.height;
          this.canvas
              .getContext('2d')
              .drawImage(img, 0, 0, img.width, img.height);

          let context = this.canvas.getContext('2d');
          let imageData = context.getImageData(0, 0, this.canvas.width, this.canvas.height);
          this.data = imageData.data;
        },
        createMap(width, height) {
            var bounds = [[0, 0], [height, width]];
            var image = L.imageOverlay(this.image, bounds).addTo(this.map);
            this.map.setMaxBounds(bounds);
            this.map.fitBounds(bounds);

            this.map.on('click', (e) => {
                const p = e.latlng;
                this.detectDeskItem([Math.floor(p.lat), Math.floor(p.lng)]);
            })

            this.add();
        },
        updatePosition(pos) {
            this.center = pos;

            let position = {
                center: pos,
                height: parseInt(this.height),
                width: parseInt(this.width),
                radius: parseInt(this.radius),
                type: this.type,
                angle: this.value? this.value.position? this.value.position.angle? this.value.position.angle: 0:0:0
            };

            let tmp = this.item;
            tmp.position = position;

            this.item = tmp;

            this.add();
        },
        add() {
            if (this.rectangle) {
                this.rectangle.remove();
            }

            this.addRectangle(this.item);
        },
        rotatePoint(point, center, angle) {
          let x = center.lng + (point.lng - center.lng) * Math.cos(angle) - (point.lat - center.lat) * Math.sin(angle);
          let y = center.lat + (point.lng - center.lng) * Math.sin(angle) + (point.lat - center.lat) * Math.cos(angle);
          return L.latLng(y, x);
        },
        rotateRectangle(item,rectangle){
          if(!rectangle || !item.position){
            return;
          }
          let center = rectangle.getBounds().getCenter();
          let rotationRadians = (item.position.angle * Math.PI) / 180;
          let rotatedCorners = rectangle.getLatLngs()[0].map((corner) => {
            return this.rotatePoint(corner, center, rotationRadians);
          });

          rectangle.setLatLngs([rotatedCorners]);
        },
        addRectangle(item) {
            if (!item.position) {
                return;
            }

            if (item.position.type === 'circle') {
                this.rectangle = L.circle(item.position.center, {color: "red", radius: item.position.radius, weight: 1})
                    .addTo(this.map);

                return;
            }

            this.rectangle = L.rectangle([
                [item.position.center[0] + item.position.height, item.position.center[1] - item.position.width],
                [item.position.center[0] - item.position.height, item.position.center[1] + item.position.width],
            ], {color: "red", weight: 1})
                .addTo(this.map);

            this.rotateRectangle(item, this.rectangle);
        },
        bfs(node) {
          const width = this.canvas.width;
          const height = this.canvas.height;
          let visited = new Map();
          let stack = [];

          let points = [];

          let left = node[0];
          let right = node[0];
          let top = node[1];
          let bottom = node[1];

          let distance = function (v1, v2) {
            let i,
                d = 0;

            for (i = 0; i < v1.length; i++) {
              d += (v1[i] - v2[i]) * (v1[i] - v2[i]);
            }
            return Math.sqrt(d);
          };

          visited.set(
              node[0] * width + node[1]
              , true);

          stack.push(node);
          points.push({x: node[0], y: node[1]});

          while (stack.length > 0) {

            let visiting = stack.pop();

            let index = (visiting[1] * width + visiting[0]) * 4;
            let masterPixel = [this.data[index], this.data[index + 1], this.data[index + 2]];

            [
              [visiting[0] + 1, visiting[1]],
              [visiting[0] - 1, visiting[1]],
              [visiting[0], visiting[1] + 1],
              [visiting[0], visiting[1] - 1],
            ]
                .filter((node) => {
                  if (visited.has(
                      node[0] * width + node[1]
                  )) {
                    return false;
                  }

                  if (node[0] < 0) {
                    return false;
                  }

                  if (node[0] > width) {
                    return false;
                  }

                  if (node[1] < 0) {
                    return false;
                  }

                  if (node[1] > height) {
                    return false;
                  }

                  return true;
                })
                .filter(node => {
                  visited.set(
                      node[0] * width + node[1],
                      true
                  );
                  let index = (node[1] * width + node[0]) * 4;
                  let slavePixel = [this.data[index], this.data[index + 1], this.data[index + 2]];

                  return distance(masterPixel, slavePixel) < 10;
                })
                .forEach((node) => {
                  left = Math.min(left, node[0]);
                  right = Math.max(right, node[0]);

                  top = Math.min(top, node[1]);
                  bottom = Math.max(bottom, node[1]);

                  stack.push(node);
                  points.push({x: node[0], y: node[1]});
                })
          }

          this.width = (right - left) / 2;
          this.height = (bottom - top) / 2;
          this.radius = Math.max(this.width, this.height);

          return [(left + right) / 2, (top + bottom) / 2];
        },
        detectDeskItem(position) {
          if(this.disableClick){
            return;
          }
          if (!this.detection) {
            return this.updatePosition(position);
          }

          let visiting = [position[1], this.canvas.height - position[0]];
          let newPosition = this.bfs(visiting);
          newPosition = [this.canvas.height - newPosition[1], newPosition[0]];
          this.updatePosition(newPosition);
        },
        rotateLeft(){
          this.value.position.angle += 10;
          this.updatePosition(this.center);
        },
        rotateRight(){
          this.value.position.angle -= 10;
          this.updatePosition(this.center);
        }
    }
}
</script>

<style scoped>

</style>